import { Head } from "zudoku/components";
import React, { useEffect } from "react";
 
export const ApiKeyLink = () => {
  useEffect(() => {
    // Open Google in new tab immediately
    const newTab = window.open("https://platform.vozzo.ai/documentation", "_blank", "noopener,noreferrer");
    
    // Redirect current tab back to home page
    setTimeout(() => {
      window.location.href = "/"; // Redirect to home page
    }, 100);
  }, []);

  return (
    <section>
      <Head>
        <title>Redirecting...</title>
      </Head>
      <div style={{ display: 'none' }}>
        {/* No visible content */}
      </div>
    </section>
  );
};